"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var TABLE_SIZES = Object.freeze({
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.TABLE_SIZES = TABLE_SIZES;